module.exports = __webpack_public_path__ + "img/bp_download_googleplay.541f7523.png";